// Fjellpota: Gratis frakt progress – Impulse events (ingen fetch-patch)
(function () {
  function getEl() {
    return document.querySelector('.free-shipping-progress[data-free-shipping-threshold]');
  }

  function getThreshold(el) {
    return parseInt(el.getAttribute('data-free-shipping-threshold'), 10) || 0;
  }

  function formatNOK(cents) {
    const kr = (cents / 100).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${kr} kr`;
  }

  function render(totalCents) {
    const el = getEl();
    if (!el) return;

    const threshold = getThreshold(el);
    if (!threshold) return;

    const textEl = el.querySelector('[data-free-shipping-text]');
    const fillEl = el.querySelector('[data-free-shipping-fill]');

    if (totalCents <= 0) {
      // skjul hvis tom kurv
      el.style.display = 'none';
      return;
    }
    el.style.display = '';

    if (totalCents >= threshold) {
      if (textEl) textEl.innerHTML = '🎉 <strong>Du har gratis frakt!</strong>';
      el.classList.add('free-shipping-progress--success');
      if (fillEl) fillEl.style.width = '100%';
      return;
    }

    const remaining = threshold - totalCents;
    if (textEl) textEl.innerHTML = `Du mangler <strong>${formatNOK(remaining)}</strong> for gratis frakt.`;
    el.classList.remove('free-shipping-progress--success');

    const pct = Math.max(0, Math.min(100, (totalCents / threshold) * 100));
    if (fillEl) fillEl.style.width = pct + '%';
  }

  async function fetchCartAndRender() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      render(cart.total_price || 0);
    } catch (e) {}
  }

  // 1) Første render
  document.addEventListener('DOMContentLoaded', fetchCartAndRender);

  // 2) Når produkt er lagt til via ajax cart (Impulse event)
  document.addEventListener('ajaxProduct:added', function () {
    // Denne eventen gir ofte product, ikke cart → hent cart én gang
    fetchCartAndRender();
  });

  // 3) Når cart er oppdatert (qty +/- / remove) – Impulse event gir cart direkte
  document.addEventListener('cart:updated', function (evt) {
    const cart = evt && evt.detail && evt.detail.cart;
    if (cart && typeof cart.total_price === 'number') {
      render(cart.total_price);
    } else {
      fetchCartAndRender();
    }
  });
})();